module.exports = __webpack_public_path__ + "static/media/em-99.9e861525.png";